// @ts-nocheck
/* eslint-disable */

import React from 'react';
import ViewEntity from '../../components/CRUD/ViewEntity';
import UserGroupMove from './UserGroupMove';
import UserInfoTabs from './UserInfoTabs';

// User info page (read-only profile) + a "Change Group" action, and a tabbed panel
// (Linked Fare Media / Group History / Eligibility Documents) like the Fare Media info page.
const ViewUser = () => {
  return (
    <ViewEntity
      pageTitle="UserInfo"
      fetchApiUrl="/api/v1/web_portal/users/:id"
      fetchApiMethod="GET"
      dataPath="data.data"
      additionalApis={[
        {
          name: 'fareMedia',
          url: (mainData) => `/api/v1/web_portal/users/${mainData.id}/fare-media`,
          method: 'GET',
          dataPath: 'data.data',
        },
        {
          name: 'groupHistory',
          url: (mainData) => `/api/v1/web_portal/users/${mainData.id}/group-history`,
          method: 'GET',
          dataPath: 'data.data',
        },
      ]}
      fields={[
        { name: 'name', labelKey: 'Name', type: 'text' },
        { name: 'phone', labelKey: 'Phone', type: 'text' },
        { name: 'email', labelKey: 'Email', type: 'text' },
        { name: 'passengers_group_name', labelKey: 'GroupName', type: 'text' },
        { name: 'wallet_balance', labelKey: 'wallet_balance', type: 'text' },
        { name: 'created_at', labelKey: 'CreatedAt', type: 'date' },
      ]}
      backUrl="/CardsManagement/users"
      backButtonLabel="Back"
      showEditButton={false}
      showDeleteButton={false}
      subsystemName="Users"
      permissionSystem="masterConfig"
      // wider container so the tabs + tables have room (default view class is 45%)
      containerStyle={{ width: '85%', maxWidth: '1200px' }}
      buildTitle={(data) => data.name || data.phone}
      // Change-group action sits next to the user's name (like edit/delete)
      renderActionButtons={(data) => (
        <UserGroupMove userId={data.id} currentGroupId={data.passengers_group_id} />
      )}
      renderBelowData={(data, additionalData) => (
        <div>
          {/* Tabbed detail: Linked Fare Media / Group History / Eligibility Documents */}
          <UserInfoTabs
            userId={data.id}
            fareMedia={(additionalData && additionalData.fareMedia) || []}
            groupHistory={(additionalData && additionalData.groupHistory) || []}
          />
        </div>
      )}
    />
  );
};

export default ViewUser;
